/**
 * Ids for rows created while the write endpoints do not exist yet.
 *
 * The real POST returns the id (and shared_uid) the rest of the chain needs, so
 * these are stand-ins only: one above the highest id already held, which keeps
 * them unique and sortable alongside the seeded rows.
 */
export function nextLocalId(rows: { id: string }[]): string {
  const highest = rows.reduce((max, row) => {
    const numeric = Number(row.id);
    return Number.isFinite(numeric) && numeric > max ? numeric : max;
  }, 0);
  return String(highest + 1);
}
